export default __webpack_public_path__ + "static/media/Spiritguard.6f2066fe.jpg";